import "./components/accessibility.js";
import "./components/animations.js";
import "./components/back-to-top.js";
import "./components/carousels.js";
import "./components/cookie-consent.js";
import "./components/cover-videos.js";
import "./components/external-links.js";
import "./components/fixed-button.js";
import "./components/floating-footer.js";
import "./components/inputs.js";
import "./components/lightboxes.js";
import "./components/notification-bar.js";
import "./components/mobile-menu.js";
// import "./components/search-suggestions.js";
import "./components/sticky-header.js";
import "./components/tabs.js";
import "./components/tooltips.js";
import "./components/weather.js";

document.addEventListener("DOMContentLoaded", function () {
	if (true === window.bds_theme.debug.enabled) {
		console.log(bds_theme);
	}
});
